import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { SecurityService } from '@infrastructure/Security/SecurityService';
import { NavigationExtras, Router, ActivatedRoute } from '@angular/router';
import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
import { DomainCodes } from '../../models/const.DomainCodes';
import { DatePipe } from '@angular/common';
import { CommonDataPipe } from '@infrastructure/CommonData/CommonDataPipe';
import { isNullOrUndefined } from '@infrastructure/objectUtils';
import { AlertService } from '@infrastructure/Alerts/alert.service';
import DateHelpers from '@infrastructure/DateHelpers';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoadingMaskService } from '@infrastructure/LoadingMask/LoadingMaskService';
import { isEmptyOrAllNull } from '@infrastructure/objectUtils';
import { ptBrLocale } from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { SessionStorageService } from '@infrastructure/SessionStorageService/SessionStorageService';
import { CommonDataService } from '@infrastructure/CommonData/CommonDataService';
import { UtilsService } from '@infrastructure/Utils/UtilsService';
import { forEach } from 'lodash';
import { DocumentosObservableService } from '@infrastructure/Documents/DocumentosObservable';
import { StateCode,StatePhase } from '@infrastructure/Models/const.stateCodePhase';
import { SystemInformationService } from '@infrastructure/SystemInformation/SystemInformationService';

//import { Positioning, PositioningOptions } from 'ngx-bootstrap/positioning';
@Component({
    selector: 'instance-browser',
    templateUrl: './instance-browser.component.html',
    styleUrls: ['./instance-browser.component.scss'],
    standalone: false
})

export class InstanceBrowserComponent implements OnInit, OnDestroy {
  modalRef: BsModalRef;
  public instances: models.InstanceBrowserVM;
  @ViewChild('warning') warning: TemplateRef<any>;
  @ViewChild('empty') empty: TemplateRef<any>;

  @CommonData(DomainCodes.instanceBrowserStatus)
  public instancesStatus: models.DimensionVM[];
  //Not used yet
  public currentPage: number;
  public expandedRowIndex: number;
  private defaultPageSize: number = 50;
  public serviceCode: string;
  public serviceName: string;
  public subscriberNumber2: number;
  public subscriberName: string
  public isObrig: boolean;
  public workflowInstance_Id: number;
  public forceNew: boolean;
  public instObri: string;
  public childWorkflow: string;
  public isVoluntaria: boolean;
  public incapacidade: boolean;
  public sobrevivencia: boolean;
  public subsidioPorMorte: boolean;
  public reembDespFuneral: boolean;
  public fundamentosLegais: string;
  public tipoSituacaoSubPedido: string;
  public tipoEstadoPedido: string;
  public tipoFasePedido: string;
  public workflowStartDateIni: Date;
  public workflowStartDateFim: Date;
  public workflowValidateDateIni: Date;
  public workflowValidateDateFim: Date;
  public workflowSubmitDateIni: Date;
  public workflowSubmitDateFim: Date;
  
  public allFundamentosLegaisValues: models.Options[] = [] as models.Options[];
  public allFundamentosLegaisAposentacao: models.Options[] = [] as models.Options[];
  public allFundamentosLegaisAContagem: models.Options[] = [] as models.Options[];
  public tiposSituacaoSubPedido: models.Options[] = [] as models.Options[];
  public tiposFasePedido: models.Options[] = [] as models.Options[];
  public tiposFasePedidoFiltrados: models.Options[] = [] as models.Options[];
  public tiposEstadoPedido: models.Options[] = [] as models.Options[];
  public tiposPedidosDropdownsValues: models.Options[] = [] as models.Options[];
  public tiposDropdownEstaPedidoValues: models.Options[] = [] as models.Options[];
  public workflowCode: string = null;
  public workflowInstanceId: number = 0;
  public message: string;

  public isAtendimento: boolean;
  public atendimentoNumber: string;
  public atendimento: string;
  public tipoUtilizador: string;
  public PGPAU: boolean = false;
  public PGPAS: boolean = false;
  public loading: string = null;

  public dadosDePesquisa: any[] = [];
  public dadosDePesquisaEmpty: string[] = [];

  public subscriberNumber: string;

  public isService: boolean;
  public hide: boolean = false;
  public isNsi: boolean = true;
  public isArrowUp: boolean = true;
  public bottonClear: boolean = true;

  public tipoDePedido: string = null;
  private mainSubscription: Subscription = new Subscription();

  private preStageRoot: models.StepPrestageRootVM = {} as models.StepPrestageRootVM;
  private preStageForm: models.StepPrestageVM = {} as models.StepPrestageVM;

  public destinoRouter: string;
  public messageCode: string;

  public user: string;
  public service: number;
  public role: string;
  private instanceId: number;
  public domain: string | null;

  constructor(private http: HttpClient, private securityService: SecurityService, private router: Router,
    private commonDataPipe: CommonDataPipe, private datePipe: DatePipe, private alertService: AlertService,
    private modalService: BsModalService, private loadingMaskService: LoadingMaskService, private localeService: BsLocaleService,
    private commonDataService: CommonDataService, private utilsService: UtilsService, private sessionStorageService: SessionStorageService,
    private documentsObservableService: DocumentosObservableService, private route: ActivatedRoute, private systemInfo: SystemInformationService ) {
    this.documentsObservableService.removeAllNotifications();
    // PIT 40803 \\
    const options: models.OrigemAcessoInstanciaVM = {
      origemDoAcesso: '/instancebrowser',
    };
    this.sessionStorageService.setOrigemPedidoOnCache(options);

    const navigation = this.router.getCurrentNavigation();

    if (!isNullOrUndefined(navigation)) {
      const state = navigation.extras.state;
      if (state) {
        this.messageCode = state.code;
        this.message = state.data;
      }
    }
    // PIT 40803 \\

    if (isNullOrUndefined(this.instances))
      this.instances = <models.InstanceBrowserVM>{};
    if (isNullOrUndefined(this.instances.instances))
      this.instances.instances = [];

    defineLocale('pt-br', ptBrLocale);
    this.localeService.use('pt-br');

    // resolve CommonData as of angular version 18 is broken
    const domainCodes: string[] = [
      DomainCodes.instanceBrowserStatus
    ];
    this.mainSubscription.add(
      this.commonDataService.getDomains(domainCodes).subscribe(results => {
        this.instancesStatus = this.utilsService.getDomainOfDomains(DomainCodes.instanceBrowserStatus, results).dimensions;
      })
    );

    //Get system information
    this.mainSubscription.add(
      this.systemInfo.loadCurrentSystemInformation().subscribe(result => {
        const idParam = this.route.snapshot.paramMap.get('instanceId');
        if (idParam !== null && idParam !== '') {
          this.instanceId = Number(idParam);
        }
        this.isNsi = (result.proveniencia == "NSI");
        if (result.workflowCode == "LST_PEDIDOS") {
          if (this.verifyInstanceIdString(result.instanceID)) {
            this.isNsi = false;
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    if (this.mainSubscription) {
      this.mainSubscription.unsubscribe();
    }
  }

  verifyInstanceIdString(instanceId: string): boolean {
    if (instanceId !== null && instanceId !== undefined) {
      return true;
    }
    if (parseInt(instanceId) > 0) {
      return false;
    }
    return true;
  }

  // PIT 40803 \\
  private getListaDePedidosOnCache() {
    const options = this.sessionStorageService.getListaDePedidosOptionOnCache();
    if (options != null) {
      this.hide = true;
      this.isArrowUp = false;
      this.bottonClear = false;

      if (this.tipoUtilizador == "A") {
        this.serviceCode = options.serviceCode;
        this.serviceName = options.serviceName;
      }
      this.subscriberNumber2 = options.subscriberNumber2;
      this.subscriberName = options.subscriberName;
      this.tipoSituacaoSubPedido = options.tipoSituacaoSubPedido;

      this.isVoluntaria = options.isVoluntaria;
      this.isObrig = options.isObrig;
      this.incapacidade = options.incapacidade;

      this.sobrevivencia = options.sobrevivencia;
      this.subsidioPorMorte = options.subsidioPorMorte;
      this.reembDespFuneral = options.reembDespFuneral;

      this.tipoDePedido = options.tipoDePedido;
      this.fundamentosLegais = options.fundamentosLegais;

      this.tipoEstadoPedido = options.tipoEstadoPedido;

      this.filterFasePedidoPorEstado(this.tipoEstadoPedido);

      this.tipoFasePedido = options.tipoFasePedido;

      this.workflowStartDateIni = options.workflowStartDateIni;
      this.workflowStartDateFim = options.workflowStartDateFim;
      this.workflowValidateDateIni = options.workflowValidateDateIni;
      this.workflowValidateDateFim = options.workflowValidateDateFim;
      this.workflowSubmitDateIni = options.workflowSubmitDateIni;
      this.workflowSubmitDateFim = options.workflowSubmitDateFim;
      
    }
  }

  ngOnInit(): void {

    this.atendimento = (this.securityService.userDetails.informationGroups.includes("PGPA") ? "A" : null);
    this.atendimentoNumber = this.securityService.userDetails.service;
    this.serviceCode = this.atendimento == "A" ? null : this.securityService.userDetails.service;
    this.subscriberNumber = this.securityService.userDetails.utente ?? null; // ? this.getUtenteTrimed() : null;

    this.tipoUtilizador = (this.atendimento == "A" ? "A" : ((!isNullOrUndefined(this.serviceCode)) ? "S" : "U"));
    this.tipoDePedido = "undefined";

    this.user = this.securityService.userDetails.userName;
    this.service = +this.securityService.userDetails.service;
    this.role = this.tipoUtilizador == "A" ? "PGPA" :
                this.tipoUtilizador == "S" ? "PGPS" :
                this.tipoUtilizador == "U" ? "PGPU" :
                null;

    const idParam = this.route.snapshot.paramMap.get('instanceId');
    if (idParam !== null && idParam !== '') {
      this.instanceId = Number(idParam);
    }
    this.hide = false;
    this.atendimento = (this.securityService.userDetails.informationGroups.includes("PGPA") ? "A" : null);
    this.atendimentoNumber = this.securityService.userDetails.service;
    this.serviceCode = this.atendimento == "A" ? null : this.securityService.userDetails.service;
    this.subscriberNumber = this.securityService.userDetails.utente ?? null; // ? this.getUtenteTrimed() : null;

    this.tipoUtilizador = (this.atendimento == "A" ? "A" : ((!isNullOrUndefined(this.serviceCode)) ? "S" : "U"));
    this.tipoDePedido = "undefined";

    this.user = this.securityService.userDetails.userName;
    this.service = +this.securityService.userDetails.service;
    this.role = this.tipoUtilizador == "A" ? "PGPA" :
                this.tipoUtilizador == "S" ? "PGPS" :
                this.tipoUtilizador == "U" ? "PGPU" :
                null;

    if (!isNaN(this.instanceId)) {
      this.isNsi = true;
      this.processNSIRequest();
      return;
    }
    else {
      this.isNsi = false;

      this.loadWorkflowDropdowns().subscribe(result => {
        this.allFundamentosLegaisValues = result.options.filter(el => el.dropdown === "dropListFundLegais");
        this.tiposPedidosDropdownsValues = result.options.filter(el => el.dropdown === "DropdownTipoDePedido");
        this.tiposSituacaoSubPedido = result.options.filter(el => el.dropdown === "DropdownSituSubsPedido");
        this.tiposFasePedido = result.options.filter(el => el.dropdown === "DropdownFasePedido");
        this.tiposDropdownEstaPedidoValues = result.options.filter(el => el.dropdown == "DropdownEstaPedido");
        this.allFundamentosLegaisAposentacao = this.allFundamentosLegaisValues.filter(el => el.type == "PEDI001");
        this.allFundamentosLegaisAContagem = this.allFundamentosLegaisValues.filter(el => el.type == "PEDI0020");

        this.hide = false;
        this.atendimento = (this.securityService.userDetails.informationGroups.includes("PGPA") ? "A" : null);
        this.atendimentoNumber = this.securityService.userDetails.service;
        this.serviceCode = this.atendimento == "A" ? null : this.securityService.userDetails.service;
        this.subscriberNumber = this.securityService.userDetails.utente ?? null; // ? this.getUtenteTrimed() : null;

        this.tipoUtilizador = (this.atendimento == "A" ? "A" : ((!isNullOrUndefined(this.serviceCode)) ? "S" : "U"));
        this.tipoDePedido = "undefined";

        this.user = this.securityService.userDetails.userName;
        this.service = +this.securityService.userDetails.service;
        this.role = this.tipoUtilizador == "A" ? "PGPA" :
          this.tipoUtilizador == "S" ? "PGPS" :
            this.tipoUtilizador == "U" ? "PGPU" :
              null;

        //const idParam = this.route.snapshot.paramMap.get('instanceId');
        //if (idParam !== null && idParam !== '') {
        //  this.instanceId = Number(idParam);

        //  if (!isNaN(this.instanceId)) {
        //    this.processNSIRequest();
        //    return;
        //  }
        //}

        //Show Loading
        this.loadingMaskService.setShowLoading(true, false);

        // PIT 40803 \\
        const validOption = ['/instancebrowser', '/workflowSearch'];
        const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

        if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
          //const oriValue = JSON.parse(dadosOrigem);
          this.destinoRouter = dadosOrigem.origemDoAcesso;
        }
        else {
          this.destinoRouter = '/workflowSearch';
        }
        // PIT 40803 \\
        if (this.tipoUtilizador == "A") {
          /******** ATENDIMENTO *******/
          // PIT 40803 \\
          this.getListaDePedidosOnCache();

          this.dadosDePesquisa = [];
          this.dadosDePesquisaEmpty = [];

          this.dadosDePesquisa.push(this.serviceCode, this.serviceName, <any>this.subscriberNumber2, this.subscriberName,
            this.fundamentosLegais, this.tipoEstadoPedido, <any>this.isObrig, <any>this.isVoluntaria,
            <any>this.incapacidade, <any>this.workflowStartDateIni, <any>this.workflowStartDateFim, <any>this.workflowValidateDateIni,
            <any>this.workflowValidateDateFim, <any>this.workflowSubmitDateIni, <any>this.workflowSubmitDateFim, <any>this.tipoDePedido,
            <any>this.tipoFasePedido, <any>this.tipoSituacaoSubPedido, this.user, this.service, this.role, this.sobrevivencia, this.subsidioPorMorte, this.reembDespFuneral);

          this.dadosDePesquisa.forEach((dados) => {
            if (dados == undefined || dados == "undefined" || dados == false) {
              this.dadosDePesquisaEmpty.push(dados);
            }
          });

          if (this.dadosDePesquisaEmpty.length != 24) {
            this.searchData();
          }
          // PIT 40803 \\
          this.isAtendimento = true;

          //Hide Loading
          this.loadingMaskService.setShowLoading(false);
        }
        else
          if (this.tipoUtilizador == "S") {
            /******** SERVIÇO *******/
            // PIT 40803 \\
            this.getListaDePedidosOnCache();

            this.loadInstances(this.serviceCode, this.tipoUtilizador, this.defaultPageSize, 0, this.serviceCode, this.serviceName, this.subscriberNumber2, this.subscriberName, this.fundamentosLegais,
              this.tipoEstadoPedido, this.isObrig, this.isVoluntaria, this.incapacidade, this.workflowStartDateIni, this.workflowStartDateFim, this.workflowValidateDateIni, this.workflowValidateDateFim,
              this.workflowSubmitDateIni, this.workflowSubmitDateFim, this.tipoFasePedido, this.tipoSituacaoSubPedido, this.user, this.service, this.role, this.sobrevivencia, this.subsidioPorMorte, this.reembDespFuneral)
              .subscribe(result => {
                this.instances = result;
                for (let instance of this.instances.instances) {
                  this.serviceName = instance.serviceName;
                }

                if (this.instances.message !== undefined) {
                  this.modalRef = this.modalService.show(
                    this.warning,
                    Object.assign({}, { class: 'modal-lg' }));
                }

                if (isEmptyOrAllNull(this.instances.instances)) {
                  this.serviceName = this.instances.serviceName;
                  this.instances.instances = [];
                }

                //Hide Loading
                this.loadingMaskService.setShowLoading(false);
              },
                error => this.loadingMaskService.setShowLoading(false)
              );
            this.isService = true;
            return;
          }
          else
            if (this.tipoUtilizador == "U") {
              /******** SUBSCRITOR *******/

              this.loadInstances(this.subscriberNumber, this.tipoUtilizador, this.defaultPageSize, 0, undefined, undefined, undefined, undefined, undefined, undefined,
                undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, this.user, this.service, this.role)
                .subscribe(result => {
                  this.instances = result;
                  if (isNullOrUndefined(this.instances.instances))
                    this.instances.instances = [];

                  //Hide Loading
                  this.loadingMaskService.setShowLoading(false);
                },
                  error => this.loadingMaskService.setShowLoading(false));
              this.isService = false;
            }
      });
    }
  }

  ngAfterViewInit(): void {
    switch (this.messageCode) {
      case 'OK': {
        this.alertService.success(this.message);
        break;
      }
      case 'INFO': {
        this.alertService.info(this.message); break;
      }
      default: {
        this.alertService.error(this.message);
        break;
      }
    }
  }

  public loadInstances(ownerNumber: string, ownerType: string, pageSize: number, pageNumber: number,
    serviceCode?: string, serviceName?: string, subscriberNumber2?: number, subscriberName?: string, fundamentosLegais?: string,
    estadoPedidos?: string, isObrig?: boolean, isVoluntaria?: boolean, incapacidade?: boolean, workflowStartDateIni?: Date, workflowStartDateFim?: Date,
    workflowValidateDateIni?: Date, workflowValidateDateFim?: Date, workflowSubmitDateIni?: Date, workflowSubmitDateFim?: Date, tipoFasePedido?: string, tipoSub?: string,
    user?: string, service?: number, role?: string, sobrevivencia?: boolean, subsidioPorMorte?: boolean, reembDespFuneral?: boolean, instanceID?: number)
    : Observable<models.InstanceBrowserVM> {

    let tipoDePedidoParameter: string = this.tipoDePedido;
    if (this.tipoDePedido === "undefined" || this.tipoDePedido === undefined) {
      tipoDePedidoParameter = null;
    }
    if (this.tipoFasePedido === "undefined" || this.tipoFasePedido === undefined) {
      tipoFasePedido = null;
    }
    if (this.tipoSituacaoSubPedido === "undefined" || this.tipoSituacaoSubPedido === undefined) {
      tipoSub = null;
    }
    this.expandedRowIndex = null;
    return this.http.get<models.InstanceBrowserVM>('api/InstanceBrowser/GetInstances',
      {
        params: {
          pageNumber: pageNumber.toString(), pageSize: pageSize.toString(), ownerNumber: ownerNumber, ownerType: ownerType,
          serviceCode: serviceCode, serviceName: serviceName?.toUpperCase(), subscriberNumber2: subscriberNumber2, subscriberName: subscriberName?.toUpperCase(), fundamentosLegais: fundamentosLegais,
          estadoPedidos: estadoPedidos, isObrig: <any>isObrig, isVoluntaria: <any>isVoluntaria, incapacidade: <any>incapacidade, workflowStartDateIni: DateHelpers.getDateText(workflowStartDateIni, this.datePipe),
          workflowStartDateFim: DateHelpers.getDateText(workflowStartDateFim, this.datePipe), workflowValidateDateIni: DateHelpers.getDateText(workflowValidateDateIni, this.datePipe),
          workflowValidateDateFim: DateHelpers.getDateText(workflowValidateDateFim, this.datePipe), workflowSubmitDateIni: DateHelpers.getDateText(workflowSubmitDateIni, this.datePipe),
          workflowSubmitDateFim: DateHelpers.getDateText(workflowSubmitDateFim, this.datePipe), tipoDePedido: tipoDePedidoParameter, fase: tipoFasePedido, tipoSub: tipoSub,
          user: user, service: service, role: role, sobrevivencia: sobrevivencia, subsidioPorMorte: subsidioPorMorte, reembDespFuneral: reembDespFuneral, instanceID: instanceID, isNsi: this.isNsi
        }
      });
  }

  public filterFundamentosByTipoPedido() {

    let valuesToReturn = [];
    let uniqueValues = [];

    if (this.tipoDePedido == null || this.tipoDePedido == "undefined" || this.tipoDePedido == undefined) return this.allFundamentosLegaisValues;

    if (this.tipoDePedido !== null && this.tipoDePedido !== "undefined" && this.tipoDePedido !== undefined) {
      if (this.tipoSituacaoSubPedido !== null && this.tipoSituacaoSubPedido !== "undefined" && this.tipoSituacaoSubPedido !== undefined) {
        valuesToReturn = this.allFundamentosLegaisValues.filter(x => x.filter == this.tipoDePedido && x.filter2 == this.tipoSituacaoSubPedido);
      }
      else {
        valuesToReturn = this.allFundamentosLegaisValues.filter(x => x.filter == this.tipoDePedido);
      }
      valuesToReturn.forEach(el => {
        const uniqueValue = uniqueValues.find(un => un.description === el.description);
        if (uniqueValue === undefined || uniqueValue === null) {
          uniqueValues.push(el);
        }
      });
      valuesToReturn = uniqueValues;
      return valuesToReturn;
    }
  }

  public expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }
  public getInstanceTypeText(instance: models.InstanceDetailVM) {
    const wft = isNullOrUndefined(instance.workflowType) ? "" : instance.workflowType;
    const wfr = isNullOrUndefined(instance.workflowReason) ? "" : instance.workflowReason;

    if (wft == "Prestações por morte"){
      return wft
    }

    return wft != "" && wfr != "" ? wft + " | " + wfr : wft + wfr
  }


  public getInstanceStatusText(instance: models.InstanceDetailVM) {
    if (instance.instanceStatus != "A")
      return this.commonDataPipe.transform(instance.instanceStatus, this.instancesStatus, 'code', 'desc');
    else
      return this.commonDataPipe.transform(instance.mandatoryInstance + instance.instancePhase, this.instancesStatus, 'code', 'desc');
  }
  public navigateToWorkflowSearch() {
    this.router.navigate(['workflowSearch']);
  }
  public navigateToInstance(instance: models.InstanceDetailVM, event:Event = null) {
    if (event !== null && event !== undefined) {
      event.stopPropagation();
    }
    let isExSubscritor = (instance.workflowCode.toUpperCase().indexOf('PEDI005') > -1 ||
      instance.workflowCode.toUpperCase().indexOf('PEDI008') > -1) ? true : false;
    let isPrestacoesPorMorte = instance.workflowCode == "PEDI002" || instance.workflowCode == "PEDI002A" ||
      instance.workflowCode == "PEDI002B"; 
    if (this.allowInstanceAccess(instance)) {

      this.loadingMaskService.setShowLoading(true);

      if (this.atendimento) {
        if (isExSubscritor) {
          this.http.get<models.WorkflowInstanceVM>('api/InstanceBrowser/InitInstanceAtendimento',
            { params: { workflowInstanceId: instance.instanceID.toString() } }
          ).subscribe(data => {
            var canInitAtend = (data.stateCode.trim().toLowerCase() == 'ok');
            this.loadingMaskService.setShowLoading(false);
            if (canInitAtend) {
              if (instance.hasMapLoaded) {
                this.router.navigate([`workflow/${instance.instanceID.toString()}/step/${instance.instanceRole == 'PGPAS' || instance.instanceRole == 'PGPS' ? 'StepServiceInfo' : 'StepSubscriberInfo'}`]);
              }
              else {
                this.navigateToReadonlyPrestage(instance);
              }
              return;
            } else {
              this.alertService.error(data.message);
            }

          });
        } else {
          //Iniciar Atendimento para X instância
          this.http.get<models.WorkflowInstanceVM>('api/InstanceBrowser/InitInstanceAtendimento',
            { params: { workflowInstanceId: instance.instanceID.toString() } }
          ).subscribe(data => {

            var canInitAtend = (data.stateCode.trim().toLowerCase() == 'ok');

            if (canInitAtend) {
              if (isPrestacoesPorMorte) {
                if ((instance.instanceStatus == StateCode.Ativo /*"A"*/ && instance.instancePhase == StatePhase.ParaPreenchimentoPeloRemetente /*"PPR"*/) ||
                  (instance.instanceStatus == StateCode.Pendente /*"P"*/ && instance.instancePhase == StatePhase.ParaValidacaoDaRepresentacao /*"PVR"*/) ||
                  (instance.instanceStatus == StateCode.Ativo /*"A"*/ && instance.instancePhase == StatePhase.ParaComplementoPeloRemetente /*"PCR"*/) ||
                  (instance.instanceStatus == StateCode.Ativo /*"A"*/ && instance.instancePhase == StatePhase.DevolvidoAoRemetente /*"DR"*/) ||
                  (instance.instanceStatus == StateCode.Invalidado && instance.instancePhase == StatePhase.RLIndeferida)) {
                  if (instance?.instanceRole == "PGPS") {
                    this.loadingMaskService.setShowLoading(false);
                    this.router.navigate([`workflow-create-pm/PEDI002/${instance.instanceID}/SenderIdentification`]);
                    return;
                  }
                  else {
                    this.loadingMaskService.setShowLoading(false);
                    this.router.navigate([`workflow-create-pm/PEDI002/${instance.instanceID}/SenderQualification`]);
                    return;
                  }
                }
                else if ((instance.instanceStatus == "A" && instance.instancePhase == "PCR") || instance.instanceStatus == "C") {
                  this.loadingMaskService.setShowLoading(false);
                  this.router.navigate([`workflow/${instance.instanceID}/PEDI002/step/StepSender`]);
                  return;
                }
              }
              else {
                this.router.navigate([`workflow/${instance.instanceID.toString()}/step/${instance.instanceRole == 'PGPAS' || instance.instanceRole == 'PGPS' ? 'StepServiceInfo' : 'StepSubscriberInfo'}`]);
              }
              
              return;
            } else {
              this.alertService.error(data.message);
            }
            this.loadingMaskService.setShowLoading(false);
          });

        }



        return;
      }

      if (instance.instanceStatus === "R") {

        if (!isExSubscritor) {
          // Inicio da validação de pré carregamento
          let forceNew = 'S';
          const validaPedido: models.ValidaPedidoRegistadoVM = {
            workflowInstanceID: instance.instanceID,
            workflowCode: instance.workflowCode,
            subscriberNumber: instance.subscriberNumber,
            forceNew: forceNew,
            instObri: instance.mandatoryInstance
          };
          this.http.post<models.WorkflowStatusVM>('api/InstanceBrowser/ValidaPedidoRegistado', validaPedido).subscribe(result => {
            this.workflowInstance_Id = result?.workflowInstanceId;
            this.loadingMaskService.setShowLoading(false);

            if (result.stateCode == 'ER') {
              this.alertService.error(result.message);
              return;
            }

            else {

              if (instance.mandatoryInstance === "S" || instance.workflowCode.includes('PEDI0020')) {
                this.http.get<models.WorkflowInstanceVM>('api/InstanceBrowser/InitInstanceAtendimento',
                  { params: { workflowInstance_Id: instance.instanceID.toString() } }
                ).subscribe(data => {
                  var canInitAtend = (data.stateCode.trim().toLowerCase() == 'ok');

                  if (canInitAtend) {
                    this.router.navigate([`workflow/${instance.instanceID.toString()}/step/${this.isService ? 'StepServiceInfo' : 'StepSubscriberInfo'}`]);
                    return;
                  } else {
                    this.alertService.error(data.message);
                    return;
                  }

                });
              }
              else {
                  this.http.get<models.InstanceBrowserVM>('api/InstanceBrowser/CanOpenRegistredInstance',
                    { params: { instanceID: instance.instanceID.toString(), subscriberNumber: instance.subscriberNumber.toString(), ownerType: this.tipoUtilizador } }
                  ).subscribe(data => {

                    var canOpen = (data.stateCode.trim().toLowerCase() == 'true');

                    if (canOpen) {
                      this.router.navigate([`workflow-create/${data.message}/${instance.instanceID}/${instance.subscriberNumber}`]);
                      return;
                    } else {
                      this.alertService.error(data.message);
                      return;
                    }

                  }, error => this.loadingMaskService.setShowLoading(false));
                }

            }

          },
            error => {
              this.loadingMaskService.setShowLoading(false);
              this.alertService.error('Generic.GlobalError');
              console.error(error);
            }
          );
          // Fim da validação de pré carregamento
        }

        else {
          this.http.get<models.InstanceBrowserVM>('api/InstanceBrowser/CanOpenRegistredInstance',
            { params: { instanceID: instance.instanceID.toString(), subscriberNumber: instance.subscriberNumber.toString(), ownerType: this.tipoUtilizador } }
          ).subscribe(data => {

            var canOpen = (data.stateCode.trim().toLowerCase() == 'true');
            this.loadingMaskService.setShowLoading(false);
            if (canOpen) {
              this.router.navigate([`workflow-create/${data.message}/${instance.instanceID}/${instance.subscriberNumber}`]);
              return;
            } else {
              this.alertService.error(data.message);
              return;
            }

          }, error => this.loadingMaskService.setShowLoading(false));
        }
      }
      else {
        //TODO passar a receber workflowcode na instancia em x de andar com workflowReasons
        // É instancia de ex-subscritor
        if (isExSubscritor) {
          // É servico
          if (this.serviceCode != null) {
            if (instance.hasMapLoaded) {
              this.router.navigate([`workflow/${instance.instanceID.toString()}/step/StepServiceInfo`]);
              return;
            }
            else {

              if (instance.instanceStatus == 'P' && instance.instancePhase == 'PCS' && instance.isSentCGA == "true")
              {
                this.acceptServiceManifest(instance);
                return;
              }
              else {
                var instancePhase = { status: instance.instanceStatus, phase: instance.instancePhase }
                const navigationExtras: NavigationExtras = {
                state: instancePhase
                };

                this.router.navigate([`workflow-create/${instance.workflowCode}/${instance.instanceID.toString()}/${instance.subscriberNumber}`], navigationExtras);
                return;
              }
            }
          }
          // É utilizador
          if (this.serviceCode == null) {
            if (instance.hasMapLoaded) {
              this.router.navigate([`workflow/${instance.instanceID.toString()}/step/StepSubscriberInfo`]);
              return;
            }
            else {
              var instancePhase = { status: instance.instanceStatus, phase: instance.instancePhase }
              const navigationExtras: NavigationExtras = {
                state: instancePhase
              };
              this.router.navigate([`workflow-create/${instance.workflowCode}/${instance.instanceID.toString()}/${instance.subscriberNumber}`], navigationExtras);
              return;
            }
          }
        }
        else {
          if (isPrestacoesPorMorte) {
            this.http.get<models.WorkflowInstanceVM>('api/InstanceBrowser/InitInstanceAtendimento',
              { params: { workflowInstanceId: instance.instanceID.toString() } }
            ).subscribe(data => {
              var canInitAtend = (data.stateCode.trim().toLowerCase() == 'ok');

              if (canInitAtend) {

                if ((instance.instanceStatus == "I" && instance.instancePhase == "RLI") ||
                  (instance.instanceStatus == "A" && instance.instancePhase == "PPR") ||
                  (instance.instanceStatus == "A" && instance.instancePhase == "DR")) {
                  if (this.tipoUtilizador == "S") {
                    this.loadingMaskService.setShowLoading(false);
                    this.router.navigate([`workflow-create-pm/PEDI002/${instance.instanceID}/SenderIdentification`]);
                    return;
                  }
                  else if (this.tipoUtilizador == "U") {
                    this.loadingMaskService.setShowLoading(false);
                    this.router.navigate([`workflow-create-pm/PEDI002/${instance.instanceID}/SenderQualification`]);
                    return;
                  }
                  
                }
                else if ((instance.instanceStatus == "A" && instance.instancePhase == "PCR") || instance.instanceStatus == "C" ) {
                  this.loadingMaskService.setShowLoading(false);
                  this.router.navigate([`workflow/${instance.instanceID}/PEDI002/step/StepSender`]);
                  return;
                }

              } else {
                this.alertService.error(data.message);
                return;
              }

            });
          } else { 
            //Não é instancia de ex-subscritor
            this.http.get<models.WorkflowInstanceVM>('api/InstanceBrowser/InitInstanceAtendimento',
              { params: { workflowInstanceId: instance.instanceID.toString() } }
            ).subscribe(data => {
              var canInitAtend = (data.stateCode.trim().toLowerCase() == 'ok');

              if (canInitAtend) {
                this.router.navigate([`workflow/${instance.instanceID.toString()}/step/${this.isService ? 'StepServiceInfo' : 'StepSubscriberInfo'}`]);
                return;
              } else {
                this.alertService.error(data.message);
                return;
              }

            });
          }
        }
      }
    }
  }

  acceptServiceManifest(instance: models.InstanceDetailVM) {

    this.loadingMaskService.setShowLoading(true, false);

    this.http.get<models.StepPrestageRootVM>('api/Workflow/LoadWorflowInstanceData', { params: { workflowInstanceId: instance.instanceID } as {} }).subscribe(result => {
      this.preStageRoot = result;
      this.preStageForm = this.preStageRoot.stepPreStage;

      //venha de CGA ou não, é necessário forçar variaveis isSentCGA a false para SP's + isPreStage fica apenas finalizado neste ponto do fluxo
      this.preStageForm.preStageInfo.isPrestageFinished = "true";
      //this.preStageForm.preStageInfo.isSentCGA = "false";
      this.preStageRoot.stepPreStage = this.preStageForm;
      //TODO instanceid parameter esta string? deve ser inteiro
      this.http.post<models.WorkflowStatusVM>('api/WorkflowInstanceCreator/AcceptPreStageManifest', this.preStageRoot, { params: { subscriberNumber: instance.subscriberNumber, instanceId: <any>instance.instanceID } })
        .subscribe(result => {
          this.loadingMaskService.setShowLoading(false);
          if (result.stateCode == 'ER') {
            //let modal = <models.BaseModalVM>{ isError: true, message: result.message };
            //this.modalS.showModals([modal]).subscribe(result => console.log(result));
            return;
          }

          //if (result.stateCode == 'OK') {
            if (instance.workflowCode.indexOf('PEDI008') > -1) {
              this.router.navigate(['workflow', this.preStageRoot.stepPreStage.preStageInfo.instance, 'step', result.stepCode]);
            }
            else if (instance.workflowCode.indexOf('PEDI005') > -1) {

              this.loadingMaskService.setShowLoading(true, true, false);
              this.http.post<models.WorkflowStatusVM>('api/WorkflowInstanceCreator/SubmitPreStageInstance', this.preStageRoot, { params: { workflowCode: this.preStageForm.preStageInfo.subscriberMotive, subscriberNumber: <any>instance.subscriberNumber, autoAccepted: 'true', forceNew: 'F' } })
                .subscribe(result => {

                  if (result.stateCode == 'ER') {
                    let modal = <models.BaseModalVM>{ isError: true, message: result.message };
                    //this.modalS.showModals([modal]).subscribe(result => console.log(result));
                    return;
                  }
                  this.router.navigate([`workflow/${this.preStageRoot.stepPreStage.preStageInfo.instance}/step/StepServiceInfo`]);
                  return;

                },
                  error => this.loadingMaskService.setShowLoading(false)

                );
            //}

          }
          else {
            //TODO
            this.loadingMaskService.setShowLoading(false)
          }
        },
          error => this.loadingMaskService.setShowLoading(false)

        );
      
    },
      error => this.loadingMaskService.setShowLoading(false)

    );    
  }

  public navigateToReadonlyPrestagePM(instance: models.InstanceDetailVM, event: Event = null) {
    if (event !== null && event !== undefined) {
      event.stopPropagation();
    }
    this.router.navigate([`workflow-create-pm/PEDI002/${instance.instanceID}/SenderQualification`])

    //var instancePhase = { status: instance.instanceStatus, phase: instance.instancePhase }
    //const navigationExtras: NavigationExtras = {
    //  state: instancePhase
    //};

  //  this.router.navigate([`workflow-create/${instance.workflowCode}/${instance.instanceID.toString()}/${instance.subscriberNumber}`], navigationExtras);
  }

  public navigateToReadonlyPrestage(instance: models.InstanceDetailVM, event:Event=null) {
    if (event !== null && event !== undefined) {
      event.stopPropagation();
    }

    var instancePhase = { status: instance.instanceStatus, phase: instance.instancePhase }
    const navigationExtras: NavigationExtras = {
      state: instancePhase
    };

    this.router.navigate([`workflow-create/${instance.workflowCode}/${instance.instanceID.toString()}/${instance.subscriberNumber}`], navigationExtras);
  }

  public navigateToInstanceManifest(instance: models.InstanceDetailVM, event: Event = null) {

    if (event !== null && event !== undefined) {
      event.stopPropagation();
    }
    let u = this.getUtenteTrimed();
    if (this.allowInstanceAccess(instance)) {
      this.router.navigate([`workflowSearch/${u}/${instance.manifestID}`]);
    }
    else return;
  }
  public allowInstanceAccess(instance: models.InstanceDetailVM):boolean {
    this.PGPAS = false;
    this.PGPAU = false;
    let isExSubscritor = (instance.workflowCode.toUpperCase().indexOf('PEDI005') > -1 || instance.workflowCode.toUpperCase().indexOf('PEDI008') > -1) ? true : false;

    //atendimento
    if (this.isAtendimento) {


      if (instance.instanceStatus == 'I' && instance.instancePhase == "RLI") {
        return true;
      }

      if (isExSubscritor && instance.instanceStatus != "I") {
        return true;
      }
      if (instance.instanceStatus == "I" ||
        (instance.instanceStatus == "P" && instance.instancePhase == "PCU") || instance.instanceStatus == "R") {
        return false;
      }
      else if (instance.instanceRole == "PGPS") {
        this.PGPAS = true;
        return  true;
      }
      else if (instance.instanceRole == "PGPU") {
        this.PGPAU = true;
        return true;
      }

    }

    //service
    if (this.isService) {
      if (instance.instanceStatus == "I" || (instance.instanceStatus == "P" && instance.instancePhase == "PCU") )
        return false;
      const result = (instance.instanceStatus == "R" ||
        instance.instanceStatus == "C" ||
        instance.instancePhase == "NPA" ||
        instance.instancePhase == "NPV" ||
        instance.instancePhase == "PCR" ||
        instance.instancePhase == "PPR" ||
        (instance.mandatoryInstance == "S" && instance.instancePhase == "SPS") ||
        (instance.instanceStatus == "P" && instance.instancePhase == "PCS"));
      return result;
    }
    //subscriber
    //if (instance.instanceStatus == "I" || instance.instanceStatus == "P")
    //return false;

    //exsubscritor
    if (isExSubscritor) {
      if ((instance.instanceStatus == "P" && instance.instancePhase == "PCS") || (instance.instanceStatus == "A" && instance.instancePhase != "NPS"))
        return false;

      return (instance.instancePhase == "C" && instance.instanceStatus == "C") || (instance.instanceStatus == "R" && instance.instancePhase == "R") || (instance.instanceStatus == "P" && (instance.instancePhase == "AIC" || instance.instancePhase == "DS" || instance.instancePhase == "PNS")) || (instance.instanceStatus == "A" && instance.instancePhase == "NPS");
    }


    return ((instance.instanceStatus == "P" && instance.instancePhase == "PCU") ||
      instance.instanceStatus == "C" ||
      (instance.instanceStatus == "A" && instance.instancePhase == "NPS" && instance.mandatoryInstance == "N") ||
      (instance.instanceStatus == "A" && instance.instancePhase == "PCR") ||
      (instance.instanceStatus == "A" && instance.instancePhase == "PPR") ||
      (instance.instanceStatus == "A" && instance.instancePhase == "DR") ||
      (instance.instanceStatus == "I" && instance.instancePhase == "RLI")
    );
  }

  public awaitingManifest(instance: models.InstanceDetailVM) {
    return instance.instanceStatus == "P";
  }

  public isVisibilityOnAtendimento(instance: models.InstanceDetailVM): boolean {
    let result = instance.instancePhase !== StatePhase.AguardaInformacaoCGA /*'AIC'*/;
    result = result || instance.instancePhase !== StatePhase.ParaValidacaoDoServicoPCS /*'PCS'*/;
    result = result || instance.instancePhase !== StatePhase.ParaValidacaoDaRepresentacao /*'PVR'*/;
    result = result || instance.instancePhase !== StatePhase.ParaComplementoPeloRemetente /*'PCR'*/;
    result = result || instance.instancePhase !== StatePhase.ParaValidacaoDoServicoPCS /*'PCS'*/;
    return result
  }

  public filterFasePedidoPorEstado(estadoCode: string) {
    this.tiposFasePedidoFiltrados = this.tiposFasePedido.filter(x => x.type == estadoCode);
    this.tipoFasePedido = undefined;
  }

  getUtenteTrimed(): string {
    var utente = this.securityService.userDetails.utente;
    return utente.split(' ')[0];
    const regex = / 00$/;
    utente = utente.replace(regex, '');
    return utente;
  }



  public exportData() {

    this.loadingMaskService.setShowLoading(true, false);

    //Validate Search
    this.dadosDePesquisa.push(this.serviceCode, this.serviceName, <any>this.subscriberNumber2, this.subscriberName,
      this.fundamentosLegais, this.tipoEstadoPedido, <any>this.isObrig, <any>this.isVoluntaria,
      <any>this.incapacidade, <any>this.workflowStartDateIni, <any>this.workflowStartDateFim, <any>this.workflowValidateDateIni,
      <any>this.workflowValidateDateFim, <any>this.workflowSubmitDateIni, <any>this.workflowSubmitDateFim, <any>this.tipoDePedido,
      <any>this.tipoFasePedido, <any>this.tipoSituacaoSubPedido);

    this.dadosDePesquisa.forEach((dados) => {
      if (dados == undefined || dados == "undefined" || dados == false) {
        this.dadosDePesquisaEmpty.push(dados);
      }
    });

    if (this.dadosDePesquisaEmpty.length == 18) {
      this.modalRef = this.modalService.show(
        this.empty,
        Object.assign({}, { class: 'modal-lg' }));

      //Hide Loading
      this.loadingMaskService.setShowLoading(false);

      if (!this.hide) {
        this.hide = true;
        this.isArrowUp = false;
      }
    }
    else {
      this.loadInstancesExport(this.serviceCode, this.tipoUtilizador, this.defaultPageSize, 0, this.serviceCode, this.serviceName,
        this.subscriberNumber2, this.subscriberName, this.fundamentosLegais, this.tipoEstadoPedido, this.isObrig, this.isVoluntaria, this.incapacidade,
        DateHelpers.dateFix(this.workflowStartDateIni), DateHelpers.dateFix(this.workflowStartDateFim), DateHelpers.dateFix(this.workflowValidateDateIni), DateHelpers.dateFix(this.workflowValidateDateFim),
        DateHelpers.dateFix(this.workflowSubmitDateIni), DateHelpers.dateFix(this.workflowSubmitDateFim), this.tipoFasePedido, this.tipoSituacaoSubPedido, this.sobrevivencia, this.subsidioPorMorte, this.reembDespFuneral).subscribe(result => {

          if (result.message !== undefined) {
            this.instances.message = result.message;
            this.modalRef = this.modalService.show(
              this.warning,
              Object.assign({}, { class: 'modal-lg' }));
          }

          const byteChar = atob(result.fileContent);
          const byteNum = Array.from(byteChar).map(char => char.charCodeAt(0));
          const byteArr = new Uint8Array(byteNum);
          const blob = new Blob([byteArr], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.target = '_blank';
          a.download = result.fileName;
          a.href = url;
          document.body.appendChild(a);
          a.click();
          a.remove();

          //Hide Loading
          this.loadingMaskService.setShowLoading(false);

        }, error => this.loadingMaskService.setShowLoading(false));
    }
  }

  public loadInstancesExport(ownerNumber: string, ownerType: string, pageSize: number, pageNumber: number,
    serviceCode?: string, serviceName?: string, subscriberNumber2?: number, subscriberName?: string, fundamentosLegais?: string,
    estadoPedidos?: string, isObrig?: boolean, isVoluntaria?: boolean, incapacidade?: boolean, workflowStartDateIni?: Date, workflowStartDateFim?: Date,
    workflowValidateDateIni?: Date, workflowValidateDateFim?: Date, workflowSubmitDateIni?: Date, workflowSubmitDateFim?: Date, tipoFasePedido?: string, tipoSub?: string,
    sobrevivencia?: boolean, subsiMorte?: boolean, reembDespFun?: boolean )
    : Observable<models.InstanceBrowserVM> {

    let tipoDePedidoParameter: string = this.tipoDePedido;
    if (this.tipoDePedido === "undefined" || this.tipoDePedido === undefined) {
      tipoDePedidoParameter = null;
    }
    if (this.tipoFasePedido === "undefined" || this.tipoFasePedido === undefined) {
      tipoFasePedido = null;
    }
    if (this.tipoSituacaoSubPedido === "undefined" || this.tipoSituacaoSubPedido === undefined) {
      tipoSub = null;
    }
    this.expandedRowIndex = null;
    return this.http.get<models.InstanceBrowserVM>('api/InstanceBrowser/GetInstancesExport',
      {
        params: {
          pageNumber: pageNumber.toString(), pageSize: pageSize.toString(), ownerNumber: ownerNumber, ownerType: ownerType,
          serviceCode: serviceCode, serviceName: serviceName?.toUpperCase(), subscriberNumber2: <any>subscriberNumber2, subscriberName: subscriberName?.toUpperCase(), fundamentosLegais: fundamentosLegais,
          estadoPedidos: estadoPedidos, isObrig: <any>isObrig, isVoluntaria: <any>isVoluntaria, incapacidade: <any>incapacidade, workflowStartDateIni: DateHelpers.getDateText(workflowStartDateIni, this.datePipe),
          workflowStartDateFim: DateHelpers.getDateText(workflowStartDateFim, this.datePipe), workflowValidateDateIni: DateHelpers.getDateText(workflowValidateDateIni, this.datePipe),
          workflowValidateDateFim: DateHelpers.getDateText(workflowValidateDateFim, this.datePipe), workflowSubmitDateIni: DateHelpers.getDateText(workflowSubmitDateIni, this.datePipe),
          workflowSubmitDateFim: DateHelpers.getDateText(workflowSubmitDateFim, this.datePipe), tipoDePedido: tipoDePedidoParameter, fase: tipoFasePedido, tipoSub: tipoSub,
          sobrevivencia: sobrevivencia, subsiMorte: subsiMorte, reembDespFun: reembDespFun
        }
      });
  }

  public searchData() {
    // PIT 40803 \\
    this.http.get<models.WorkflowStatusVM[]>('api/Workflow/ValidaDisponibilidadePGPCall', {}).subscribe((result: any) => {

      if (result.stateCode == 'I') {
        this.router.navigate(['validatepgponline']);
        return;
      } else {
          const options: models.ListaPedidosOptionsVM = {
            //timestamp: new Date(),

            subscriberNumber2: this.subscriberNumber2,
            subscriberName: this.subscriberName,
            tipoSituacaoSubPedido: this.tipoSituacaoSubPedido,

            serviceCode: this.serviceCode,
            serviceName: this.serviceName,

            isVoluntaria: this.isVoluntaria,
            isObrig: this.isObrig,
            incapacidade: this.incapacidade,

            sobrevivencia: this.sobrevivencia,
            subsidioPorMorte: this.subsidioPorMorte,
            reembDespFuneral: this.reembDespFuneral,

            tipoDePedido: this.tipoDePedido,
            fundamentosLegais: this.fundamentosLegais,

            tipoEstadoPedido: this.tipoEstadoPedido,
            tipoFasePedido: this.tipoFasePedido,

            workflowStartDateIni: this.workflowStartDateIni,
            workflowStartDateFim: this.workflowStartDateFim,
            workflowValidateDateIni: this.workflowValidateDateIni,
            workflowValidateDateFim: this.workflowValidateDateFim,
            workflowSubmitDateIni: this.workflowSubmitDateIni,
            workflowSubmitDateFim: this.workflowSubmitDateFim,

          };

          this.sessionStorageService.setListaDePedidosOptionOnCache(options);
          // PIT 40803 \\

          if (!this.hide) {
            this.hide = true;
            this.isArrowUp = false;
            this.bottonClear = false;
          }
          else {
            //Show Loading
            this.loadingMaskService.setShowLoading(true, false);

            if (!this.isAtendimento) {
              this.loadInstances(this.serviceCode, this.tipoUtilizador, this.defaultPageSize, 0, this.serviceCode, this.serviceName,
                this.subscriberNumber2, this.subscriberName, this.fundamentosLegais, this.tipoEstadoPedido, this.isObrig, this.isVoluntaria, this.incapacidade,
                DateHelpers.dateFix(this.workflowStartDateIni), DateHelpers.dateFix(this.workflowStartDateFim), DateHelpers.dateFix(this.workflowValidateDateIni), DateHelpers.dateFix(this.workflowValidateDateFim),
                DateHelpers.dateFix(this.workflowSubmitDateIni), DateHelpers.dateFix(this.workflowSubmitDateFim), this.tipoFasePedido, this.tipoSituacaoSubPedido,
                this.user, this.service, this.role, this.sobrevivencia, this.subsidioPorMorte, this.reembDespFuneral).subscribe(result => {
                  this.instances = result;
                  if (this.instances.message !== undefined) {
                    this.modalRef = this.modalService.show(
                      this.warning,
                      Object.assign({}, { class: 'modal-lg' }));
                  }

                  if (isNullOrUndefined(this.instances.instances))
                    this.instances.instances = [];

                  //Hide Loading
                  this.loadingMaskService.setShowLoading(false);

                }, error => this.loadingMaskService.setShowLoading(false));
            }
            else {
              
              // PIT 40803 \\
              this.dadosDePesquisa = [];
              this.dadosDePesquisaEmpty = [];
              // PIT 40803 \\

              //Validate Search
              this.dadosDePesquisa.push(this.serviceCode, this.serviceName, <any>this.subscriberNumber2, this.subscriberName,
                this.fundamentosLegais, this.tipoEstadoPedido, <any>this.isObrig, <any>this.isVoluntaria,
                <any>this.incapacidade, <any>this.workflowStartDateIni, <any>this.workflowStartDateFim, <any>this.workflowValidateDateIni,
                <any>this.workflowValidateDateFim, <any>this.workflowSubmitDateIni, <any>this.workflowSubmitDateFim, <any>this.tipoDePedido,
                <any>this.tipoFasePedido, <any>this.tipoSituacaoSubPedido, this.user, this.service, this.role, this.sobrevivencia, this.subsidioPorMorte, this.reembDespFuneral);

              this.dadosDePesquisa.forEach((dados) => {
                if (dados == undefined || dados == "undefined" || dados == false) {
                  this.dadosDePesquisaEmpty.push(dados);
                }
              });

              if (this.dadosDePesquisaEmpty.length == 24) {
                this.modalRef = this.modalService.show(
                  this.empty,
                  Object.assign({}, { class: 'modal-lg' }));

                //Hide Loading
                this.loadingMaskService.setShowLoading(false);
              }
              else {
                this.loadInstances(this.atendimentoNumber, this.tipoUtilizador, this.defaultPageSize, 0, this.serviceCode, this.serviceName,
                  this.subscriberNumber2, this.subscriberName, this.fundamentosLegais, this.tipoEstadoPedido, this.isObrig, this.isVoluntaria, this.incapacidade,
                  DateHelpers.dateFix(this.workflowStartDateIni), DateHelpers.dateFix(this.workflowStartDateFim), DateHelpers.dateFix(this.workflowValidateDateIni),
                  DateHelpers.dateFix(this.workflowValidateDateFim),
                  DateHelpers.dateFix(this.workflowSubmitDateIni),
                  DateHelpers.dateFix(this.workflowSubmitDateFim), this.tipoFasePedido, this.tipoSituacaoSubPedido, this.user, this.service, this.role,
                  this.sobrevivencia, this.subsidioPorMorte, this.reembDespFuneral).subscribe(result => {
                    this.instances = result;

                    if (this.instances.message !== undefined) {
                      this.modalRef = this.modalService.show(
                        this.warning,
                        Object.assign({}, { class: 'modal-lg' }));
                    }

                    if (isNullOrUndefined(this.instances.instances))
                      this.instances.instances = [];

                    //Hide Loading
                    this.loadingMaskService.setShowLoading(false);

                  }, error => this.loadingMaskService.setShowLoading(false));
              }

              //Clear Search Data
              this.dadosDePesquisa = [];
              this.dadosDePesquisaEmpty = [];
            }
          }
      }
    },
      error => this.loadingMaskService.setShowLoading(false)
    );
  }

  public showHide() {
    this.hide = false;
    this.isArrowUp = true;
    this.bottonClear = true;
  }

  // PIT 40803 \\
  public clearData() {
    
    if (this.tipoUtilizador == "A") {
      this.serviceCode = undefined;
      this.serviceName = undefined;
    }
    this.subscriberNumber2 = undefined;
    this.subscriberName = undefined;
    this.tipoSituacaoSubPedido = undefined;

    this.isVoluntaria = undefined;
    this.isObrig = undefined;
    this.incapacidade = undefined;

    this.sobrevivencia = undefined;
    this.subsidioPorMorte = undefined;
    this.reembDespFuneral = undefined;

    this.tipoDePedido = undefined;
    this.fundamentosLegais = undefined;

    this.tipoEstadoPedido = undefined;
    this.tipoFasePedido = undefined;

    this.workflowStartDateIni = undefined;
    this.workflowStartDateFim = undefined;
    this.workflowValidateDateIni = undefined;
    this.workflowValidateDateFim = undefined;
    this.workflowSubmitDateIni = undefined;
    this.workflowSubmitDateFim = undefined;

    this.sessionStorageService.removeListaDePedidosOption();

    if (this.tipoUtilizador == "A") {
      /******** ATENDIMENTO *******/

      this.instances.instances = [];

    }
    else if (this.tipoUtilizador == "S") {
      /******** SERVIÇO *******/
      //adicionar apenas os campos necessários
      this.loadInstances(this.serviceCode, this.tipoUtilizador, this.defaultPageSize, 0)
        .subscribe(result => {
          this.instances = result;
          for (let instance of this.instances.instances) {
            this.serviceName = instance.serviceName;
          }
          if (isEmptyOrAllNull(this.instances.instances)) {
            this.serviceName = this.instances.serviceName;
            this.instances.instances = [];
          }

          //Hide Loading
          this.loadingMaskService.setShowLoading(false);
        },
          error => this.loadingMaskService.setShowLoading(false)
        );
      this.isService = true;
    }

    return;
  }

  public getDateText(date: Date) {
    let dateText = DateHelpers.getDateText(date, this.datePipe);
    if (dateText == "") {
      return "N/A";
    } else {
      return dateText;
    }
      
  }

  public getServiceName(instance: models.InstanceDetailVM):string {
    let serviceName = instance.serviceName;
    return serviceName;
  }

  public getEstado(instance: models.InstanceDetailVM): string {
    let estado = this.tiposDropdownEstaPedidoValues.find(el => el.value == instance.instanceStatus).description;
    return estado;
  }

  public loadWorkflowDropdowns() {
    return this.http.get<models.WorkflowDropdownsVM>('api/Workflow/LoadWorkflowDropdowns', { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } });
  }

  public chooseFundamentos() {

  }

  public loadWorkflowInstance(workflowInstanceId: number, loading: string) {
    return this.http.get<models.WorkflowInstanceVM>('api/Workflow/LoadWorkflowInstance', { params: { workflowInstanceId: this.workflowInstanceId, loading: this.loading } });
  }

  public checkClick(event): void {
    let target = event.target || event.srcElement || event.currentTarget;
    let clickedId = target.attributes.id.value;

    if (this.isVoluntaria && clickedId == "obrigatoria") {
      this.isVoluntaria = false;
    }
    else
      if (!this.isVoluntaria && clickedId == "voluntaria")
        this.isObrig = false;
  }

  public TipoPedidoChanged() {
    if (this.tipoDePedido === null || this.tipoDePedido === undefined || this.tipoDePedido === 'undefined' || this.tipoDePedido?.indexOf('CT') > -1 || this.tipoDePedido?.indexOf('PM') > -1 || this.tipoDePedido?.indexOf('AP') > -1) {
      this.fundamentosLegais = undefined;
      this.isObrig = undefined;
      this.isVoluntaria = undefined;
      this.incapacidade = undefined;
      this.sobrevivencia = undefined;
      this.subsidioPorMorte = undefined;
      this.reembDespFuneral = undefined;
    }
  }

  public TipoFasePedidoChanged() {
    this.fundamentosLegais = undefined;
    this.isObrig = undefined;
    this.isVoluntaria = undefined;
    this.incapacidade = undefined;
    this.sobrevivencia = undefined;
    this.subsidioPorMorte = undefined;
    this.reembDespFuneral = undefined;
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  onDateChange(event: any, dp: any) {
    var object: any
        
    switch (event.target.name) {
      case 'workflowStartDateFim': {
        object = new Date(this.workflowStartDateFim).toISOString().split('T')[0];
        break;
      }
      case 'workflowValidateDateFim': {
        object = new Date(this.workflowValidateDateFim).toISOString().split('T')[0];
        break;
      }
      case 'workflowSubmitDateFim': {
        object = new Date(this.workflowSubmitDateFim).toISOString().split('T')[0];
        break;
      }
    }

    DateHelpers.onDateChange(event, dp, object);
  }

  // PIT 40803 \\
  public clearCache() {
    this.sessionStorageService.removeListaDePedidosOption();
  }

  public processNSIRequest() {
    var instances: models.InstanceBrowserVM;
    var instance: models.InstanceDetailVM;
    var owner;
    //Validar se é Serviço ou Subscritor
    if (this.tipoUtilizador == 'U') {
      owner = this.subscriberNumber;
    }
    else if (this.tipoUtilizador == 'S') {
      owner = this.serviceCode
    }
    else {
      owner = this.atendimentoNumber;
    }

    this.loadInstances(owner, this.tipoUtilizador, this.defaultPageSize, 0, undefined, undefined, undefined, undefined, undefined,
      undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined,
      undefined, undefined, undefined, undefined, this.user, undefined, undefined, undefined, undefined, undefined, this.instanceId).subscribe(result => {
        instances = result;

        if (isNullOrUndefined(instances.instances))
          instances.instances = [];
        else {
          instance = instances.instances[0];
        }

        if (this.tipoUtilizador == "A") { //Atendimento
          if (this.isVisibilityOnAtendimento(instance) && this.allowInstanceAccess(instance))
            this.navigateToInstance(instance, null);

          if (this.awaitingManifest(instance) && (this.checkAtendimentoPhases(instance)))
            this.navigateToReadonlyPrestage(instance, null);
        }
        else if (this.tipoUtilizador == "S") { //Serviço
          if (this.allowInstanceAccess(instance))
            this.navigateToInstance(instance, null)
        }
        else { //Subscritor
          if (this.awaitingManifest(instance) && this.checkSubscritorPhases1(instance) && this.allowInstanceAccess(instance))
            this.navigateToInstanceManifest(instance, null)

          if (this.awaitingManifest(instance) && (this.checkSubscritorPhases2(instance)))
            this.navigateToReadonlyPrestagePM(instance, null)

          if (this.awaitingManifest(instance) && this.checkSubscritorStatusPhases(instance))
            this.navigateToReadonlyPrestage(instance, null)

          if ((!this.awaitingManifest(instance) || this.checkSubscritorStatusPhases2(instance)) && this.allowInstanceAccess(instance))
            this.navigateToInstance(instance, null)
        }
      }
    );
  }

  public checkAtendimentoPhases(instance: models.InstanceDetailVM) {
    return instance.instancePhase === 'AIC' || instance.instancePhase === 'PCS';
  }

  public checkSubscritorPhases1(instance: models.InstanceDetailVM) {
    return instance.instancePhase != 'DS' && instance.instancePhase != 'PNS' && instance.instancePhase != 'PCS' && instance.instancePhase != 'AIC' && instance.instancePhase != 'PVR' && instance.instancePhase != 'PCR';
  }

  public checkSubscritorPhases2(instance: models.InstanceDetailVM) {
    return instance.instancePhase == 'PVR' || instance.instancePhase == 'DR';
  }

  public checkSubscritorStatusPhases(instance: models.InstanceDetailVM) {
    return instance.instanceStatus == 'P' && (instance.instancePhase == 'AIC' || instance.instancePhase == 'PCS');
  }

  public checkSubscritorStatusPhases2(instance: models.InstanceDetailVM) {
    return (instance.instanceStatus == 'P' && instance.instancePhase == 'PNS') || (instance.instanceStatus == 'P' && instance.instancePhase == 'DS') || (instance.instanceStatus == 'I' && instance.instancePhase == 'RLI');
  }

  
}
